import { Navigate, useLocation } from 'react-router-dom';

import { useAuthSession } from '../contexts/AuthContext.jsx';
import { useDemoMode } from '../contexts/DemoModeContext.jsx';

/**
 * ProtectedRoute — guards the authenticated shell.
 *
 * Demo mode (?demo=true) bypasses auth entirely so sales demos can browse
 * the seed-data product without logging in. In every other case, the user
 * must have a valid JWT in localStorage that /auth/me accepted.
 */
export default function ProtectedRoute({ children }) {
  const isDemo = useDemoMode();
  const { isAuthenticated, isLoading } = useAuthSession();
  const location = useLocation();

  if (isDemo) return children;

  if (isLoading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-bg">
        <div className="text-sm text-text-secondary">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
